import {Component, inject, input} from '@angular/core';
import {ProductCardData, ProductCardParameters} from "../../../types/product-card-data.types";
import {defaultProductCardData} from "../../../configs/default-product-card-data";
import {fieldToIdKey, productCardParameterFields} from "../../../configs/pc-property-lazy-select-data";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {MatTooltipModule} from "@angular/material/tooltip";
import {ProductCardModalsService} from "../../../services/product-card-modals.service";
import {ProductCardSyncDialogData} from "../../modals/product-card-sync-modal/types/product-card-sync-modal.types";
import {linkTypeProductCardSyncParams} from "../../modals/product-card-sync-modal/configs/product-card-sync-tabs";

@Component({
  selector: 'div[app-pc-parameters]',
  standalone: true,
  imports: [
    MatFormField,
    MatLabel,
    MatInput,
    MatIcon,
    MatIconButton,
    MatTooltipModule
  ],
  templateUrl: './pc-parameters.component.html',
  styleUrl: './pc-parameters.component.scss'
})
export class PcParametersComponent {
  productCardData = input<ProductCardData>(defaultProductCardData);

  private productCardModalsService: ProductCardModalsService = inject(ProductCardModalsService);

  public readonly productCardParameterFields = productCardParameterFields;

  public getValue(key: string): string {
    return (this.productCardData()[key] as ProductCardParameters)?.value || '';
  }

  public async handleOpenModal(key: string): Promise<void> {
    const idKey = fieldToIdKey[key as keyof typeof fieldToIdKey];
    const data: ProductCardSyncDialogData = {
      productCardId: this.productCardData().id,
      linkType: linkTypeProductCardSyncParams[key],
      [idKey]: (this.productCardData()[key] as ProductCardParameters)?.id
    };

    await this.productCardModalsService.openSyncModal(data);
  }
}
